import CONTRACT_ACTIONS from '../actions/contractActions';

export default function reducer(state, action){
  switch(action.type){
    case CONTRACT_ACTIONS.SET_DATE:
      return{
        ...state,
        details: {
          ...state.details,
          payday: action.value
        }
      }
    case CONTRACT_ACTIONS.SET_DISPLAY_DATE:
      return{
        ...state,
        details: {
          ...state.details,
          displayDate: action.value
        }
      }
    case CONTRACT_ACTIONS.SET_DURATION:
      return{
        ...state,
        details: {
          ...state.details,
          duration: action.value
        }
      }
    case CONTRACT_ACTIONS.SET_TYPE:
      return{
        ...state,
        details: {
          ...state.details,
          type: action.value
        }
      }
    case CONTRACT_ACTIONS.SET_BOND_VALUES:
      return{
        ...state,
        details: {
          ...state.details,
          bond_months: action.value.bond_months,
          bond_value: action.value.bond_value
        }
      }
    case CONTRACT_ACTIONS.SET_PROPOSITION_ID:
      return {
        ...state,
        id: action.value
      }
    default: 
      return state;
  }
};

export const propositionInitalState = {
  id: '',
  duration: 1,
  tenant_id: '',
  details: {
    signing: {
      place: '',
      day: '',
      month: '',
      year: ''
    },
    start_date: '',
    end_date: '',
    payday: '',
    displayDate: '',
    bond_value: '',
    bond_months: '',
    type: '',
    insurer: 'REFUSED'
  }
}